import { render, staticRenderFns } from "./wxReg.vue?vue&type=template&id=8f6cb492&scoped=true"
import script from "./wxReg.vue?vue&type=script&lang=js"
export * from "./wxReg.vue?vue&type=script&lang=js"
import style0 from "./wxReg.vue?vue&type=style&index=0&id=8f6cb492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6cb492",
  null
  
)

export default component.exports